import {useNavigate, useSearchParams} from "react-router-dom";
import {rrcEp10WasteManifestSelector, useGetRrcEp10WasteManifestQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {
  RrcEp10WasteManifestProfile
} from "../../components/profile/RrcEp10WasteManifestProfile/RrcEp10WasteManifestProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
  tenantCode?: string;
}

export const RrcEp10WasteManifestProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;
  const tenantCode = params.get("tenantCode") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.rrclep10wastemanifest", "RRC EP-10 Waste Manifest") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <RrcEp10WasteManifestProfilePage id={id} tenantCode={tenantCode}/>;
};

export const RrcEp10WasteManifestProfilePage = (props: Props) => {
  const {id, tenantCode} = props;

  const selectRrcEp10WasteManifest = useMemo(() => {
    return rrcEp10WasteManifestSelector()
  }, []);

  const {rrcEp10WasteManifest, isFetching} = useGetRrcEp10WasteManifestQuery(id ? {
    id: id,
    tenantCode: tenantCode
  } : skipToken, {
    selectFromResult: (result) => ({
      rrcEp10WasteManifest: selectRrcEp10WasteManifest(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage
      entity={rrcEp10WasteManifest}
      isLoading={isFetching}
      permissions={["rrcep10wastemanifest_view"]}
    >
      {(entity) => (
        <RrcEp10WasteManifestProfile rrcEp10WasteManifest={entity}/>
      )}
    </EntityProfilePage>
  )
};
